import React from 'react';
import { observer } from 'mobx-react-lite';
import { downloadFile } from 'polotno/utils/download';
import { getProjectName } from '../ma-helperfunctions/ma-helperfunctions';
import { Classes, Popover2 } from '@blueprintjs/popover2';

import {
  Button,
  Navbar,
  Alignment,
  InputGroup,
  Menu,
  MenuItem
} from '@blueprintjs/core';


import styled from 'polotno/utils/styled';
import MaGuardarLivraria from './ma-guardarlivraria';

const NavbarContainer = styled('div')`
  @media screen and (max-width: 500px) {
    overflow-x: auto;
    overflow-y: hidden;
    max-width: 100vw;
  }
`;

const NavInner = styled('div')`
  @media screen and (max-width: 500px) {
    display: flex;
  }
`;

export default observer(({ store }) => {
  const inputRef = React.useRef();

  const [warning, setWarning] = React.useState(true);
  const [storeStatus, setStoreStatus] = React.useState(false);

  store.on('change', () => {
    const jsonPages = store.toJSON().pages;

    jsonPages.forEach(page => {
      if (page.children.length > 0) {
        setStoreStatus(true);
      } else {
        setStoreStatus(false);
        setTimeout(() => {
          setStoreStatus(true);
        }, 1 * 60 * 1000);
      }
    });
  });

  return (
    <NavbarContainer className='bp3-navbar top-nav'>
      <NavInner className='top-nav-inner'>
        <Navbar.Group align={Alignment.LEFT}>
          <h1 className='title'>Signage Designer</h1>
        </Navbar.Group>

        <Navbar.Group align={Alignment.CENTER}>
          <InputGroup
            id='titleWorkName'
            className='edit-name-input'
            type='text'
            autoComplete='off'
            placeholder='Editar nome projeto'
            leftIcon='document'
            large
            onChange={(e) => {
              window.fileName = e.target.value.replaceAll(' ', '_');
              if (window.fileName.length === 0) {
                setWarning(true);
                setStoreStatus(false);
                setTimeout(() => {
                  setStoreStatus(true);
                }, 1 * 60 * 1000);
              } else {
                setWarning(false);
                setStoreStatus(true);
              }
            }}
          />
        </Navbar.Group>

        <Navbar.Group align={Alignment.RIGHT}>
          <Popover2
            popoverClassName={Classes.POPOVER2_CONTENT_SIZING}
            interactionKind='click'
            placement='bottom'
            content={
              <div className='popup-holder'>
                <p style={{ fontSize: '16px', lineHeight: '27px', textAlign: 'center' }}>Deseja criar um novo projeto? O trabalho actual será perdido</p>
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: 15 }}>
                  <Button
                    className={Classes.POPOVER2_DISMISS}
                    outlined
                    text='Cancelar'
                  >
                  </Button>
                  <Button
                    className={Classes.POPOVER2_DISMISS}
                    intent='primary'
                    text='Confirmar'
                    style={{ marginLeft: 10 }}
                    onClick={() => {
                      window.fileName = '';
                      const pagesIds = store.pages.map((p) => p.id);
                      store.deletePages(pagesIds);
                      store.addPage();
                      setStoreStatus(true);
                    }}
                  >
                  </Button>
                </div>
              </div>
            }
          >
            <Button
              icon='new-object'
              text='Novo'
              minimal
            />
          </Popover2>

          <label htmlFor='load-project'>
            <Button
              icon='folder-open'
              text='Abrir'
              minimal
              onClick={() => {
                document.querySelector('#load-project').click();
              }}
            />
            <input
              type='file'
              id='load-project'
              accept='.json,.polotno'
              ref={inputRef}
              style={{ width: '180px', display: 'none' }}
              onChange={(e) => {
                var input = e.target;

                if (!input.files.length) {
                  return;
                }

                var reader = new FileReader();
                reader.onloadend = function () {
                  var text = reader.result;
                  let json;
                  try {
                    json = JSON.parse(text);
                  } catch (e) {
                    alert('Não foi possível carregar o projeto.');
                  }


                  if (json) {
                    store.loadJSON(json);
                  }
                };
                reader.onerror = function () {
                  alert('Não foi possível carregar o projeto.');
                };
                reader.readAsText(input.files[0]);
              }}
            />
          </label>

          <MaGuardarLivraria store={store} warning={warning} setStoreStatus={setStoreStatus} />

          <Popover2
            interactionKind='click'
            placement='bottom'
            content={
              <Menu>
                <MenuItem
                  icon='media'
                  text='Guardar como imagem'
                  onClick={async () => {
                    var fileName = getProjectName();
                    store.pages.forEach(element => {
                      store.saveAsImage({
                        fileName: fileName,
                        pageId: element.id
                      })
                    });
                  }}

                />

                <MenuItem
                  icon='document'
                  text='Guardar como json'
                  onClick={() => {
                    const json = store.toJSON();

                    var fileName = getProjectName();
                    fileName += '.json'

                    const url =
                      'data:text/json;base64,' +
                      window.btoa(unescape(encodeURIComponent(JSON.stringify(json))));
                    downloadFile(url, fileName, json);
                  }}
                />
              </Menu>
            }>
            <Button
              text='Download'
              icon='import'
              minimal
            />
          </Popover2>

          {storeStatus ? (
            <Popover2
              popoverClassName={Classes.POPOVER2_CONTENT_SIZING}
              interactionKind='click'
              placement='bottom'
              content={
                <div className='popup-holder'>
                  <p style={{ fontSize: '16px', lineHeight: '27px', textAlign: 'center' }}>
                    Guarde o seu projeto antes de fechar.
                  </p>
                  <div style={{ display: 'flex', justifyContent: 'center', marginTop: 15 }}>
                    <Button
                      className={Classes.POPOVER2_DISMISS}
                      outlined
                      text='Cancelar'
                    >
                    </Button>
                    <Button
                              style={{ marginLeft: 10 }}
                      className={Classes.POPOVER2_DISMISS}
                      intent='primary'
                      text='Fechar'
                      onClick={() => {
                        var signage = window.parent;
                        signage.document.getElementById('iframe-holder').classList.remove('is-active');
                          signage.document.getElementById('iframe').setAttribute('src', '');
                          signage.document.getElementById('designer-access').classList.remove('activo');
                          signage.location.reload();
                      }}
                    >
                    </Button>
                  </div>
                </div>
              }
            >
              <Button
                style={{ marginLeft: '10px' }}
                rightIcon='cross'
                text='Fechar'
                intent='primary'
              />
            </Popover2>
          ) : (
            <Button
              style={{ marginLeft: '10px' }}
              rightIcon='cross'
              text='Fechar'
              intent='primary'
              
              onClick={() => {
                var signage = window.parent;
                signage.document.getElementById('iframe-holder').classList.remove('is-active');
                  signage.document.getElementById('iframe').setAttribute('src', '');
                  signage.document.getElementById('designer-access').classList.remove('activo');
                  signage.location.reload();
              }}
            />
          )}

        </Navbar.Group>
      </NavInner>
    </NavbarContainer >
  );
});
